import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import getAlertFullStatus from "../../model/alerts/getAlertFullStatus";
import formatValue from "../AlertListItem/formatValue";

const AlertDetails = props => (
  <div style={{ display: "flex", gap: "40px", alignItems: "center" }}>
    <div>
      <span style={{ fontWeight: "bold" }}>Raised:</span>
      <span style={{ marginLeft: "10px" }}>
        {moment(props.alert.opened).format("D MMM YY, HH:mm")}
      </span>
    </div>
    <div>
      <span style={{ fontWeight: "bold" }}>Status:</span>
      <span style={{ marginLeft: "10px" }}>
        {getAlertFullStatus(props.alert)}
      </span>
    </div>
    <div>
      <span style={{ fontWeight: "bold" }}>Value:</span>
      <span style={{ marginLeft: "10px" }}>
        {formatValue(props.alert.value)}
      </span>
    </div>
  </div>
);

AlertDetails.propTypes = {
  alert: PropTypes.object.isRequired
};

export default AlertDetails;
